import ChevronRight from '@eduzz/houston-icons/ChevronRight';
import HTable from '@eduzz/houston-ui/Table';
import Typography from '@eduzz/houston-ui/Typography';
import React, { useCallback } from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import Truncate from 'v2/components/Shared/TruncateText';
import { affiliateCommissionsService } from 'v2/services/reports/affiliateCommissions';

import { useStyles } from './styles';

interface IProps {
  handleSeeDetailsClick: (affiliate_id: number) => void;
}

export const Table = ({ handleSeeDetailsClick }: IProps) => {
  const classes = useStyles();

  useObservable(() => affiliateCommissionsService.loadCommissions(), []);
  const [commissions] = useObservable(() => affiliateCommissionsService.getCommissions(), []);
  const [isLoading] = useObservable(() => affiliateCommissionsService.isLoading(), []);
  const [pagination] = useObservable(() => affiliateCommissionsService.getPaginationResponse(), []);

  const onChangePerPage = useCallback(
    (per_page: number) => {
      affiliateCommissionsService.setPagination({ ...pagination, per_page, current_page: 1 });
      document.getElementById('commissions-affiliates-table').scrollIntoView();
    },
    [pagination]
  );

  const onChangePage = useCallback(
    (page: number) => {
      affiliateCommissionsService.setPagination({ ...pagination, current_page: page });
      document.getElementById('commissions-affiliates-table').scrollIntoView();
    },
    [pagination]
  );

  return (
    <HTable id='commissions-affiliates-table' total={pagination?.total_items || 0} data-testid='commissions-affiliates-table' loading={isLoading}>
      <HTable.Header>
        <HTable.Column width={440}>Afiliado</HTable.Column>
        <HTable.Column width={400}>Quantidade de Comissões</HTable.Column>
        <HTable.Column width={300} align='right'>
          Total de comissão paga (líquido)
        </HTable.Column>
        <HTable.Column width={240} />
      </HTable.Header>
      <HTable.Body>
        {commissions?.map((commission, index) => (
          <HTable.Row className={classes.row} data={commission} index={index} key={`${commission.id}`}>
            <HTable.Cell>
              {commission?.name && (
                <>
                  <Typography size='xxs'>
                    <Truncate count={25} final='...'>
                      <a
                        href={`https://app.selectafiliados.com.br/affiliate/detailsSource/${commission?.id}`}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        {commission?.name || ''}
                      </a>
                    </Truncate>
                  </Typography>
                  <Typography size='xxs'>
                    <Truncate count={25} final='...'>
                      {commission?.email || ''}
                    </Truncate>
                  </Typography>
                </>
              )}
              {!commission?.name && <span>-</span>}
            </HTable.Cell>
            <HTable.Cell>
              <Typography size='xxs'>{commission?.total_commissions || 0}</Typography>
            </HTable.Cell>
            <HTable.Cell align='right'>
              <Typography weight='semibold'>
                <FormattedNumber value={commission?.total_gain || 0} format='BRL' />
              </Typography>
            </HTable.Cell>
            <HTable.Cell>
              <p className={classes.seeDetailsText} onClick={() => handleSeeDetailsClick(commission.id)}>
                Ver detalhes <ChevronRight className={classes.seeDetailsIcon} size={20} />
              </p>
            </HTable.Cell>
          </HTable.Row>
        ))}
      </HTable.Body>
      {!isLoading && (
        <HTable.Pagination
          page={pagination?.current_page}
          perPage={pagination?.per_page}
          optionsPerPage='10,25,50'
          onChangePage={onChangePage}
          onChangePerPage={onChangePerPage}
        />
      )}
    </HTable>
  );
};
